import { createAsyncThunk } from '@reduxjs/toolkit';
import { deleteAdminPageNote } from '@/lib/api-server/admin/page/note/deleteAdminPageNote';
import { IAdminSlice, TAdminPageNote } from '@/redux/slices/admin/types';

export const deleteComment = createAsyncThunk(
  'admin/deleteComment',
  async (uuid: string, { rejectWithValue }) =>
    await deleteAdminPageNote(uuid).then((r) => {
      if (!r.success) return rejectWithValue(r.error);
    })
);

const pending = (
  state: IAdminSlice,
  { meta: { arg: uuid } }: { meta: { arg: string } }
) => {
  state.pages = state.pages.map((page: any) => ({
    ...page,
    notes: page.notes?.map((note: TAdminPageNote) => {
      if (note.uuid === uuid) {
        return {
          ...note,
          deleting: true,
        };
      }

      return note;
    }),
  }));
};

const rejected = (
  state: IAdminSlice,
  { meta: { arg: uuid } }: { meta: { arg: string } }
) => {
  state.pages = state.pages.map((page: any) => ({
    ...page,
    notes: page.notes?.map((note: TAdminPageNote) => {
      if (note.uuid === uuid) {
        return {
          ...note,
          deleting: false,
        };
      }

      return note;
    }),
  }));
};

const fulfilled = (
  state: IAdminSlice,
  { meta: { arg: uuid } }: { meta: { arg: string } }
) => {
  state.pages = state.pages.map((page: any) => {
    if (page.notes?.find((note) => note.uuid === uuid)) {
      return {
        ...page,
        notes: page.notes.filter((note) => note.uuid !== uuid),
        notes_length: page.notes_length - 1,
      };
    }
    return page;
  });
};

export default {
  action: deleteComment,
  pending,
  rejected,
  fulfilled,
};
